import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_arrow_left",
  "use": "icon-icon_arrow_left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_arrow_left\"><defs><style></style></defs><path d=\"M353.69 512l370.892-371.098a25.6 25.6 0 1 0-36.25-36.25l-389.12 389.12a25.6 25.6 0 0 0 0 36.25l389.12 389.12a25.6 25.6 0 0 0 36.25-36.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol